// extracted by mini-css-extract-plugin
export default {"container":"Dialog_container__AqZkS","header":"Dialog_header__ZgZGL","back":"Dialog_back__KC1gB","body":"Dialog_body__kRRaz"};